import moduleBreadcrumbs from 'Modules/contacard/moduleBreadcrumbs';

export default [
  ...moduleBreadcrumbs,
];
